module.exports = __webpack_public_path__ + "img/client.cfbe6f48.svg";